<div class="card-skeleton">
  <p-skeleton width="50%" height="2rem"></p-skeleton>
  <p-skeleton [height]="bodyHeight"></p-skeleton>
  <p-skeleton width="30%" height="2.5rem" borderRadius="4px"></p-skeleton>
</div>
